import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, shareReplay } from 'rxjs';
import { ProductWithLoBAndTenantDTO } from '@app/shared/models/product-lob-tenant.model';
import { PLATFORM_API_URL } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(PLATFORM_API_URL);
  private productsCache$: Observable<ProductWithLoBAndTenantDTO[]> | null = null;

  getProductsWithLinesOfBusiness(): Observable<ProductWithLoBAndTenantDTO[]> {
    if (!this.productsCache$) {
      this.productsCache$ = this.http.get<ProductWithLoBAndTenantDTO[]>(`${this.apiUrl}/api/Product/GetProductsWithLinesOfBusiness`).pipe(
        shareReplay(1)
      );
    }
    return this.productsCache$;
  }

  getHHProductWithLinesOfBusiness(): Observable<ProductWithLoBAndTenantDTO | undefined> {
    return this.getProductsWithLinesOfBusiness().pipe(
      map(products => products?.find(p =>
        p.shortName?.toLocaleLowerCase().trim() === 'hh'
      ))
    );
  }

  getPACProductWithLinesOfBusiness(): Observable<ProductWithLoBAndTenantDTO | undefined> {
    return this.getProductsWithLinesOfBusiness().pipe(
      map(products => products?.find(p =>
        p.shortName?.toLocaleLowerCase().trim() === 'pac'
      ))
    );
  }

  getDMEProductWithLinesOfBusiness(): Observable<ProductWithLoBAndTenantDTO | undefined> {
    return this.getProductsWithLinesOfBusiness().pipe(
      map(products => products?.find(p =>
        p.shortName?.toLocaleLowerCase().trim() === 'dmepos'
      ))
    );
  }
}
